module.exports = __webpack_public_path__ + "static/media/job.aca723a8.svg";